import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import * as i5 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { getStepStatusUpdate } from 'visa-store';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i3 from 'ngx-toastr';
import * as i4 from 'authentication';

class APIReviewComments {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getI140ReviewComments(visatype, caseType, caseId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/review`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    postI140ReviewComments(visatype, caseType, caseId, payload) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/review`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
}
APIReviewComments.ɵfac = function APIReviewComments_Factory(t) { return new (t || APIReviewComments)(i0.ɵɵinject(i1.HttpClient)); };
APIReviewComments.ɵprov = i0.ɵɵdefineInjectable({ token: APIReviewComments, factory: APIReviewComments.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIReviewComments, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseReviewCommentsLibraryService {
    constructor(store, apiService, toastr, authenticationService, guard) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.authenticationService = authenticationService;
        this.guard = guard;
        this.observableSubscription$ = new Subject();
        this.listDocuments = [];
        this.isUserHasReviewerPermission = false;
        this.disabledControls = false;
    }
    loadInit() {
        var _a;
        this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response[0] && response[0].status === 200) {
                this.getReviewComments();
            }
        });
        this.getReviewComments();
        const currentUserFromSession = !!(sessionStorage.getItem('currentUser')) ? JSON.parse(sessionStorage.getItem('currentUser')) : null;
        this.isUserHasReviewerPermission = this.authenticationService.currentUserValue ? this.authenticationService.currentUserValue['permissions'].find(x => x === 'PETITION_REVIEWER') ? true : false : (((_a = currentUserFromSession === null || currentUserFromSession === void 0 ? void 0 : currentUserFromSession.permissions) === null || _a === void 0 ? void 0 : _a.includes('PETITION_REVIEWER')) ? true : false);
    }
    ngAfterViewInit() {
        this.reviewCommentForm.valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            if (this.reviewCommentForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getReviewComments() {
        this.apiService.getI140ReviewComments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response && response.data && response.data.length > 0) {
                this.listDocuments = response.data.filter((x) => {
                    return x['docs'] = x['docs'].filter(y => y['docName'] !== 'Other' && y.isGenerated);
                });
            }
        });
    }
    handleSave(currentItem, refItem = null) {
        const payload = {
            "comments": currentItem.comments,
            "petitionId": this.inputData.caseId,
            "titleSheetDetailId": currentItem.titleSheetDetailId,
            "titleSheetId": refItem ? refItem.titleSheetId : currentItem.titleSheetId,
        };
        this.apiService.postI140ReviewComments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.toastr.success(response.message, 'Success');
            this.store.dispatch(new MarkCleanFormAction({
                dirty: false
            }));
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseReviewCommentsLibraryService.ɵfac = function BaseReviewCommentsLibraryService_Factory(t) { return new (t || BaseReviewCommentsLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIReviewComments), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.AuthenticationService), i0.ɵɵinject(i5.DirtyFormGuard)); };
BaseReviewCommentsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseReviewCommentsLibraryService, factory: BaseReviewCommentsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseReviewCommentsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIReviewComments }, { type: i3.ToastrService }, { type: i4.AuthenticationService }, { type: i5.DirtyFormGuard }]; }, null); })();

/*
 * Public API Surface of base-review-comments-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIReviewComments, BaseReviewCommentsLibraryService };
//# sourceMappingURL=base-review-comments-library.js.map
